import React from "react";
import { NumberInput, SelectInput, RadioGroup } from "@/components/tools/Inputs";
import {
  GOAL_OPTIONS,
  MARITAL_OPTIONS,
  TIME_HORIZON_OPTIONS,
} from "@/lib/applyForm";

export const Step1 = ({ data, onChange, errors }) => {
  const set = (k) => (v) => onChange({ ...data, [k]: v });

  const toggleGoal = (goalValue) => {
    const current = new Set(data.goals);
    if (current.has(goalValue)) current.delete(goalValue);
    else current.add(goalValue);
    onChange({ ...data, goals: Array.from(current) });
  };

  return (
    <div data-testid="apply-step-1" className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <NumberInput
          label="Your age"
          value={data.age}
          onChange={set("age")}
          min={0}
          max={110}
          testId="apply-age"
          error={errors.age}
        />
        <SelectInput
          label="Marital status"
          value={data.marital_status}
          onChange={set("marital_status")}
          options={MARITAL_OPTIONS}
          testId="apply-marital"
        />
        <NumberInput
          label="# of dependents"
          value={data.dependents}
          onChange={set("dependents")}
          min={0}
          max={10}
          testId="apply-dependents"
          error={errors.dependents}
        />
        <SelectInput
          label="Time horizon"
          value={data.time_horizon}
          onChange={set("time_horizon")}
          options={TIME_HORIZON_OPTIONS}
          testId="apply-horizon"
        />
      </div>

      <div>
        <span className="block font-sans-ui text-sm font-medium text-lw-navy mb-2">
          Primary goal(s) — pick all that apply
        </span>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {GOAL_OPTIONS.map((g) => {
            const selected = data.goals.includes(g.value);
            return (
              <button
                type="button"
                key={g.value}
                onClick={() => toggleGoal(g.value)}
                data-testid={`apply-goal-${g.value}`}
                className={`px-4 py-3 rounded-xl border text-sm font-medium text-left transition-all ${
                  selected
                    ? "border-lw-gold bg-lw-gold/10 text-lw-navy shadow-sm"
                    : "border-lw-navy/15 bg-white text-lw-navy/80 hover:border-lw-navy/30"
                }`}
              >
                {g.label}
              </button>
            );
          })}
        </div>
        {errors.goals && (
          <span className="mt-2 block text-xs text-red-600">{errors.goals}</span>
        )}
      </div>
    </div>
  );
};

export default Step1;
